import React, { useEffect } from "react";
import AOS from "aos";

// Material-UI Components
import { Box, Typography, Grid } from "@mui/material";

// Material-UI Icons
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

function AboutUs() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <Box
      data-aos="fade-up"
      sx={{
        padding: { xs: "16px", sm: "32px", md: "48px" },
        bgcolor: "#023047",
        color: "white",
        minHeight: "100vh",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mb: 3,
          color: "white",
        }}
      >
        About Us 🌟
      </Typography>

      <Box
        sx={{
          bgcolor: "#EFEAE3",
          borderRadius: "10px",
          color: "black",
          my: 10,
          p: 4,
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12}>
            <Typography
              variant="body1"
              paragraph
              sx={{
                lineHeight: 1.6,
              }}
            >
              <PlayArrowRoundedIcon />
              We are individuals who come together and share common interest,{" "}
              <strong>putting our ideas into existence</strong> in order to{" "}
              contribute to the Microsoft Community. 💡
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> Yes, we are the{" "}
              <strong>MSTC-Microsoft Student Technical Club</strong> of DAIICT.
              We try to make{" "}
              <strong>
                <em>"I don't know"</em>
              </strong>{" "}
              into{" "}
              <strong>
                <em>"I don't know yet" </em>
              </strong>{" "}
              🧠.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> Many people have genuine ideas related to
              app and web development, but there is no proper platform provided
              to them. We, as MSTC, come here and help them give the right
              environment to nurture their ideas and develop for Microsoft. 🚀
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> If you want to find answers to your
              questions, share ideas, solve problems, or whatever may be your
              goal, <strong>MSTC</strong> is here to help you get more out of
              your ideas and technology. 🙌
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> We also come up with various events and
              competitions which would help you to create a strong foundation
              for your dream competitions like those of Imagine Cup. 🏆 We are
              here to make you experience the Windows development environment
              and encourage you to develop and contribute towards the same. 💻
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default AboutUs;
